import React, { useState } from "react";
import { loginToFrappe, getLoggedUser } from "../api/authf";

export default function FrappeLoginPage({ onLogin }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);

        try {
            // 1) Login (sets sid cookie in browser)
            const loginRes = await loginToFrappe({ username, password });

            // 2) Confirm who is logged in
            const user = await getLoggedUser();

            // 3) Store data (whatever you need)
            localStorage.setItem("frappe_login_response", JSON.stringify(loginRes));
            localStorage.setItem("frappe_user", user);

            onLogin({ user, loginRes });
        } catch (error) {
            setErr(
                error?.response?.data?.message ||
                error?.message ||
                "Login failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: 360, margin: "60px auto", padding: 16 }}>
            <h2>Login</h2>

            <form onSubmit={handleLogin}>
                <div style={{ marginBottom: 10 }}>
                    <label>Email / Username</label>
                    <input
                        style={{ width: "100%", padding: 10 }}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="user@example.com"
                        required
                    />
                </div>

                <div style={{ marginBottom: 10 }}>
                    <label>Password</label>
                    <input
                        style={{ width: "100%", padding: 10 }}
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="******"
                        required
                    />
                </div>

                {err && <div style={{ color: "red", marginBottom: 10 }}>{err}</div>}

                <button
                    type="submit"
                    disabled={loading}
                    style={{ width: "100%", padding: 10 }}
                >
                    {loading ? "Logging in..." : "Login"}
                </button>
            </form>
        </div>
    );
}
